import { lazy } from 'react';

export const VendorList = lazy(() => import('./VendorList'));
export const VendorDetails = lazy(() => import('./VendorDetails'));
export const VendorServiceList = lazy(() => import('./VendorServiceList'));
